import { useState } from 'react'
import { ChevronDown } from 'lucide-react'

import { cn } from '@/lib/utils'

/**
 * @param {{
 *   id: string,
 *   icon: import('lucide-react').LucideIcon,
 *   title: string,
 *   description?: string,
 *   defaultOpen?: boolean,
 *   embedded?: boolean,
 *   children: import('react').ReactNode,
 * }} props
 */
export function SettingsSection({
  id,
  icon: Icon,
  title,
  description,
  defaultOpen = false,
  embedded = false,
  children,
}) {
  const [open, setOpen] = useState(defaultOpen)

  if (embedded) {
    return (
      <section id={`${id}-panel`} className="salon-settings-card px-4 py-4 md:px-6 md:py-5">
        {description ? (
          <p className="mb-4 text-sm text-muted-foreground">{description}</p>
        ) : null}
        {children}
      </section>
    )
  }

  return (
    <section className="salon-settings-card overflow-hidden">
      <button
        type="button"
        id={`${id}-trigger`}
        aria-expanded={open}
        aria-controls={`${id}-panel`}
        className="flex w-full items-center gap-4 px-4 py-4 text-left"
        onClick={() => setOpen((current) => !current)}
      >
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-primary/10 text-primary">
          <Icon className="h-5 w-5" aria-hidden />
        </div>
        <div className="min-w-0 flex-1">
          <p className="font-semibold text-foreground">{title}</p>
          {description ? (
            <p className="mt-0.5 text-sm text-muted-foreground">{description}</p>
          ) : null}
        </div>
        <ChevronDown
          className={cn(
            'h-5 w-5 shrink-0 text-muted-foreground transition-transform',
            open && 'rotate-180',
          )}
          aria-hidden
        />
      </button>
      {open ? (
        <div id={`${id}-panel`} className="border-t border-border/50 px-4 py-4">
          {children}
        </div>
      ) : null}
    </section>
  )
}
